module.exports = __webpack_public_path__ + "files/0b7704568b9e23476f76bf7cc36f8b3c.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/ubuntu-italic-webfont.ttf
 ** module id = 1033
 ** module chunks = 0
 **/